const events = {
  all: 'Tous',
  general: {
    search: 'Rechercher un événement',
    add: 'Ajouter',
    assign: 'Attribuer',
    details: "Détails de l'événement",
    fetchError: 'Impossible de récupérer les données',
  },
  selectors: {
    selector2: {
      access: 'Accès',
      security: 'Sécurité',
      alarms: 'Alarmes',
      troubles: 'Problèmes',
      lockdown: 'Confinement',
      others: 'Autres',
      cloud: 'Cloud',
    },
    selector3: {
      organization: 'Compte',
      site: 'Site',
      controller: 'Contrôleur',
      door: 'Porte',
      accessLevel: "Niveau d'accès",
      card: 'Identifiant',
      user: 'Utilisateur',
      schedule: 'Horaire',
      holiday: 'Fériés',
      reader: 'Lecteur',
    },
  },
  table: {
    date_and_time: 'Date et heure',
    description: 'Description',
    object: 'Objet',
    detail: 'Détail',
    info: 'Info',
    extraInfo: 'Informations supplémentaires',
    instigator: 'Instigateur',
    event: 'Événement',
    type: 'Type',
    id: 'ID',
    displayName: "Nom d'affichage",
    module: 'Module',
    sequenceNumber: 'Numéro de séquence',
  },
};

export default events;
